import React, { useState } from 'react'
import { Modal } from 'antd'
import { useNewsClickMutation } from '../store/ReactWebSiteApi'
import NewsDesc from './NewsDesc'

function WebNewsCheck(props) {
    const [open, setOpen] = useState(false)
    const [add] = useNewsClickMutation()
    return (
        <>
            <span
                role="button"
                tabIndex={0}
                onClick={() => {
                    add({ en_id: props.en_id }).then((res) => {
                        if (res.data.Status === 'success') {
                            console.log('success')
                        }
                        if (res.data.Status === 'fail') {
                            console.log(res.data.Message)
                        }
                    })
                    setOpen(true)
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        e.currentTarget.click()
                    }
                }}
                style={{ fontSize: 17, color: '#1677ff', cursor: 'pointer' }}
            >
                {props.text}
            </span>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false)
                }}
                onOk={() => {}}
                footer={null}
                width="100%"
                style={{ top: 8, maxWidth: '100vw' }}
                styles={{ body: { maxHeight: '85vh', overflowY: 'auto' } }}
            >
                <NewsDesc en_id={props.en_id} />
            </Modal>
        </>
    )
}

export default WebNewsCheck
